import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField } from "@material-ui/core";

import { withRouter } from "react-router-dom";

import { getUserInfo, getCustomFileInfoList } from "../../actions/subscribe";

import store from "../../store";

import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { Table, DatePicker, Button, Input, Select } from 'antd';

const { Option } = Select;
import axios from 'axios'

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      marginTop: "12px",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    list: {
      width: "1px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    switch: {
      width: "68px !important",
      height: "22px !important",
      padding: "0 12px !important",
      "& .MuiSwitch-track": {
        width: "44px",
        height: "22px",
        borderRadius: "11px",
      },
      "& .MuiSwitch-switchBase": {
        padding: "0",
        "&:hover": {
          background: "none",
        },
        "&.Mui-checked+.MuiSwitch-track": {
          backgroundColor: "#3DBD7D",
        },
        "& .MuiTouchRipple-root": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
        "& .MuiSwitch-thumb": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
      },
    },
    switchLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#5F6876",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#3276C3",
        borderColor: "#3276C3",
      },
    },
    select: {
      width: '100%'
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    }
  };
};

class Custom extends Component {
  state = {
    keyword: "",
    error: "",
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    modalTitle: "",
    openMessage: "",
    fileTotal: 0,
    errorMessage: "",
    push: true,
    openModal: false,
    isFirst: true,
    fileList: [],
    domain: "https://fdsroche.anwin.co",
    updateTime: '',
    searchHistoryList: [],
    form: {
      keyword: "",
    },
    defaultForm: { // 默认值
      keyword: "",
    },
    labelObj: { // 筛选项key - label对应关系
      keyword: '关键词',
    },
    labelListObj: { 
      type: 'searchTypeList'
    },
    selectKeys: ['type'],
    searchTypeList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'all',
        Name: '全文搜索'
      },
    ],
    loading: false,
    data: [],
    columns: [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 120,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.dfs_url, row.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 120,
      },
      {
        title: '文件名称',
        dataIndex: 'file_name',
        key: 'file_name',
        width: 240,
        render: (text, row) => (<a onClick={() => this.previewFile(row.dfs_url)} className={this.props.classes.linkText} >{row.file_name}</a>)
      },
      {
        title: '文件描述',
        dataIndex: 'file_index',
        key: 'file_index',
        width: 120,
      },
      {
        title: '网页链接',
        dataIndex: 'dfs_url',
        key: 'dfs_url',
        width: 240,
        render: (text, row) => (<a target="_blank" href={row.dfs_url}>{row.dfs_url}</a>)
      },
    ],
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      current: 1,
      pageSize: 10,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
    },
  };

  componentDidMount() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let keyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          keyword
        }
      }, () => {this.loadMore()})
    } else {
      this.loadMore();
    }


  }

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  resetForm = () => {
    this.setState({
      form: {
        keyword: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.loadMore())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.loadMore())
  }

  searchForm = () => {
    let paginationObj = {
      ...this.state.paginationObj,
      current: 1
    }
    this.setState({
      paginationObj: paginationObj
    }, () => this.loadMore())
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };

  loadMore = (isInit) => {
    const param = {
      file_name__icontains: this.state.form.keyword,
      dfs_url__icontains: this.state.domain,
      page: this.state.paginationObj.current,
      pageSize: this.state.paginationObj.pageSize
    };
    getCustomFileInfoList(param).then((res) => {
      if (res && res.results) {
        let data = res.results
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
        paginationObj: pagination
      },
      () => {
        this.loadMore();
      }
    );
  };
  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入关键词"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">定制文件</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Custom));
